import "./../styles/main.scss";
import $ from "jquery";
import { Datepicker } from "vanillajs-datepicker";
import { Sortable } from "sortablejs";
var feather = require('feather-icons');
require("./helpers/SymfonyCollection");
require("./helpers/FilePond");
require("./helpers/actions");
require("./helpers/form");
require("./helpers/analytics");
$(document).ready(function (e) {
    if ($('.Button.upload').length) {
        $('.Button.upload').on("click", function (e) {
            e.preventDefault();
            $(e.currentTarget).parent().next().fadeIn(250);
            $(e.currentTarget).fadeOut(250);
        });
    }
    if ($('#taskswrapper').length) {
        Sortable.create(document.getElementById("taskswrapper"), {
            handle: '.nb-task',
            onEnd: function (evt) {
                $('.Task').each(function (i, v) {
                    $(v).find('.nb-task').html(i + 1);
                    $(v).find("input[id$='position']").val(i + 1);
                });
            }
        });
        $('#taskswrapper').find(".Task").each(function (i, e) {
            var qty = $(e).find(".qty");
            var commission = $(e).find(".commission");
            var type = $(e).find(".type").find("select").val();
            switch (type) {
                case "production":
                    qty.addClass("hidden");
                    if (qty.find("input").val() == "") {
                        qty.find("input").val(1);
                    }
                    commission.removeClass("hidden");
                    break;
                default:
                    commission.addClass("hidden");
                    qty.removeClass("hidden");
                    if (commission.find("input").val() == "") {
                        commission.find("input").val(0);
                    }
                    break;
            }
        });
    }
    $(".date-input").each(function (k, v) {
        var datepicker = new Datepicker(v, {
            autohide: true,
            format: 'dd/mm/yyyy'
        });
    });
    if ($('.Message').length) {
        setTimeout(function () {
            $('.Message').fadeOut(500, function () {
                $('.Message').remove();
            });
        }, 5000);
    }
    $("#app-header").on("click", ".menu-dropdown", function (e) {
        e.preventDefault();
        $(e.currentTarget).next("ul").toggleClass("active");
        $("#app-header").toggleClass("menu-active");
    });
    $('.slug-form').on("change", "select", function (e) {
        var isClient = $(e.currentTarget).attr("name") == "client";
        var value = $(e.currentTarget).val();
        document.location.href = document.location.protocol + "//" + document.location.host + "/crm/document?status=invoice&" + (isClient ? "client=" : "slug=") + value;
    });
    $("#main-content-wrapper").on("click", function (e) {
        $('.menu-dropdown + ul.active').removeClass("active");
        $("#app-header").removeClass("menu-active");
    });
    $("aside").on("click", ".nav-dropdown > a", function (e) {
        e.preventDefault();
        $(e.currentTarget).parent().toggleClass("open");
    });
    feather.replace();
    if ($("#system-translation-manage").length) {
        var baseStr = "";
        $('.form-message').on("focus", function () {
            baseStr = $(this).val();
        });
        $('.form-message').on("blur", function () {
            var $this = $(this);
            if ($this.val() != baseStr) {
                $.post("/system/translation/update", {
                    message: $this.data("message"),
                    value: $this.val(),
                    language: $this.data("language")
                }, function () {
                });
            }
        });
    }
    if ($(".tab-wrapper.ajax").length) {
        $(".ajax > .nav.nav-tabs").on("click", "a", function (e) {
            e.preventDefault();
            var parent = $(e.currentTarget).parent();
            parent.parent().children(".active").removeClass("active");
            parent.addClass("active");
            parent.parent().next(".tab-content").children().hide();
            $($(e.currentTarget).attr("href")).show();
        });
    }
    if ($(".planning-wrapper").length) {
        // $(".planning-wrapper").on("click", ".task", (e) => {
        //     $(e.currentTarget).find(".informations").slideToggle(400);
        // });
    }
});
